export default __webpack_public_path__ + "static/media/tutors.586770db.svg";